import ReactDOM from "react-dom/client";

import { App } from "~/app";

const rootElement = document.getElementById("app");
if (!rootElement) {
  throw new Error(
    "Failed to find the root element. Ensure the HTML contains an element with id='app'.",
  );
}

const root = ReactDOM.createRoot(rootElement);
const app = import.meta.env.DEV ? (
  // TODO: Restore StrictMode after monthly-app release
  // <StrictMode>
  <App />
  //</StrictMode>
) : (
  <App />
);
root.render(app);
